export enum Markets {
    // GLOBAL = 'global',
    KR = 'kr',
}
